export { default } from '@shikijs/langs/wasm'
